<div class="container-link d-flex flex-column justify-content-center align-items-center" [class.container-link-form]="isPublicLinkForm" [style]="background" [class.custom-background]="background">

    <div *ngIf="publicLink && isPublicLinkForm">

        <ng-container *ngIf="publicLink.client">
            <img [src]="publicLink.client.file_name" [alt]="publicLink.client.name" class="logo" *ngIf="publicLink.client.file_name">
            <h2 class="name" *ngIf="!publicLink.client.file_name">{{ publicLink.client.name }}</h2>
        </ng-container>

        <ng-container *ngIf="publicLink.account && !publicLink.client">
            <img [src]="publicLink.account.file_name" [alt]="publicLink.account.name" class="logo" *ngIf="publicLink.account.file_name">
            <h2 class="name" *ngIf="!publicLink.account.file_name">{{ publicLink.account.name }}</h2>
        </ng-container>

    </div>

    <div class="content-link">
        <router-outlet></router-outlet>
    </div>

</div>
